import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import React from 'react';
import Box from '@mui/material/Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function IndicatorBadgeTick(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    sx = props.sx;
  return /*#__PURE__*/_jsx(Box, {
    sx: _extends({}, sx),
    "data-element": "Box",
    "data-component": "IndicatorBadgeTick",
    "data-source-file": "IndicatorBadgeTick.tsx",
    children: /*#__PURE__*/_jsxs("svg", {
      fill: "none",
      height: tickSize[size].size,
      viewBox: "0 0 32 32",
      width: tickSize[size].size,
      xmlns: "http://www.w3.org/2000/svg",
      "data-element": "svg",
      "data-source-file": "IndicatorBadgeTick.tsx",
      children: [_g || (_g = /*#__PURE__*/_jsxs("g", {
        clipPath: "url(#clip0_835_9319)",
        "data-element": "g",
        "data-source-file": "IndicatorBadgeTick.tsx",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M24.7116 5.66721C25.0155 6.40224 25.5989 6.98649 26.3334 7.29151L28.9092 8.35843C29.6443 8.66292 30.2283 9.24694 30.5328 9.98202C30.8373 10.7171 30.8373 11.543 30.5328 12.2781L29.4666 14.8521C29.162 15.5875 29.1616 16.4142 29.4676 17.1493L30.5319 19.7224C30.6829 20.0865 30.7606 20.4768 30.7606 20.8709C30.7607 21.265 30.6831 21.6553 30.5323 22.0194C30.3815 22.3836 30.1604 22.7144 29.8816 22.993C29.6029 23.2717 29.272 23.4927 28.9078 23.6434L26.3339 24.7096C25.5989 25.0135 25.0146 25.5968 24.7096 26.3314L23.6427 28.9072C23.3382 29.6423 22.7541 30.2263 22.0191 30.5308C21.284 30.8353 20.458 30.8353 19.723 30.5308L17.149 29.4646C16.4139 29.1609 15.5883 29.1615 14.8536 29.4663L12.2779 30.5317C11.5432 30.8355 10.718 30.8353 9.9835 30.531C9.24901 30.2268 8.66532 29.6435 8.36062 28.9092L7.29339 26.3326C6.98946 25.5976 6.40609 25.0133 5.67152 24.7083L3.09575 23.6414C2.36098 23.337 1.77713 22.7534 1.47254 22.0187C1.16795 21.2841 1.16753 20.4585 1.47139 19.7236L2.53755 17.1496C2.84128 16.4145 2.84066 15.5889 2.53582 14.8542L1.4712 12.2766C1.32025 11.9125 1.24253 11.5223 1.24247 11.1282C1.2424 10.734 1.32 10.3438 1.47083 9.97962C1.62165 9.6155 1.84275 9.28466 2.12149 9.00601C2.40022 8.72737 2.73113 8.50638 3.09531 8.35567L5.66923 7.28951C6.40362 6.98586 6.98752 6.40322 7.29277 5.6695L8.35969 3.09372C8.66418 2.35864 9.2482 1.77461 9.98328 1.47013C10.7184 1.16565 11.5443 1.16565 12.2794 1.47013L14.8533 2.53629C15.5884 2.84002 16.4141 2.8394 17.1487 2.53456L19.7256 1.47178C20.4605 1.16747 21.2863 1.16754 22.0212 1.47196C22.7562 1.77638 23.3401 2.36023 23.6447 3.09513L24.7119 5.67167L24.7116 5.66721Z",
          fill: "#0788F5",
          "data-element": "path",
          "data-source-file": "IndicatorBadgeTick.tsx"
        }), /*#__PURE__*/_jsx("path", {
          clipRule: "evenodd",
          d: "M22.2665 11.8058C22.4803 11.4701 22.5519 11.0631 22.4656 10.6746C22.3794 10.286 22.1423 9.94759 21.8065 9.73383C21.4708 9.52006 21.0638 9.44843 20.6753 9.5347C20.2867 9.62097 19.9483 9.85806 19.7345 10.1938L13.8605 19.4238L11.1725 16.0638C10.924 15.753 10.5622 15.5536 10.1667 15.5095C9.77118 15.4655 9.37436 15.5803 9.06352 15.8288C8.75269 16.0773 8.55331 16.4391 8.50923 16.8347C8.46516 17.2302 8.58001 17.627 8.82852 17.9378L12.8285 22.9378C12.9776 23.1244 13.1691 23.2727 13.387 23.3703C13.6049 23.468 13.843 23.5122 14.0815 23.4993C14.32 23.4864 14.5519 23.4167 14.758 23.2961C14.9641 23.1755 15.1385 23.0074 15.2665 22.8058L22.2665 11.8058V11.8058Z",
          fill: "white",
          fillRule: "evenodd",
          "data-element": "path",
          "data-source-file": "IndicatorBadgeTick.tsx"
        })]
      })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
        "data-element": "defs",
        "data-source-file": "IndicatorBadgeTick.tsx",
        children: /*#__PURE__*/_jsx("clipPath", {
          id: "clip0_835_9319",
          "data-element": "clipPath",
          "data-source-file": "IndicatorBadgeTick.tsx",
          children: /*#__PURE__*/_jsx("rect", {
            fill: "white",
            height: "32",
            width: "32",
            "data-element": "rect",
            "data-source-file": "IndicatorBadgeTick.tsx"
          })
        })
      }))]
    })
  });
}
var tickSize = {
  '2xl': {
    size: 20
  },
  '3xl': {
    size: 24
  },
  '4xl': {
    size: 32
  },
  lg: {
    size: 16
  },
  md: {
    size: 14
  },
  sm: {
    size: 12
  },
  xl: {
    size: 18
  },
  xs: {
    size: 10
  }
};